// @mui
import { Theme, SxProps } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
//
import CasEmptyContent from '../CasEmptyContent/CasEmptyContent';
// ----------------------------------------------------------------------

type Props = {
  notFound: boolean;
  sx?: SxProps<Theme>;
};

export default function CasTableNoData({ notFound, sx }: Props) {
  return (
    <TableRow>
      {notFound ? (
      <TableCell colSpan={5}>
        <CasEmptyContent
          filled
          title="No Data"            
        />
      </TableCell>
      ) : (
        <TableCell colSpan={5} sx={{ p: 0 }} />
      )}
    </TableRow>
  );
}
